import { render } from "./WareHouseListPage.vue?vue&type=template&id=5664d4ae&scoped=true"
import script from "./WareHouseListPage.vue?vue&type=script&lang=js"
export * from "./WareHouseListPage.vue?vue&type=script&lang=js"

import "./WareHouseListPage.vue?vue&type=style&index=0&id=5664d4ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5664d4ae"

export default script